// Componente de skeleton para el formulario de creación de clientes - Skeleton component for client creation form
// Muestra placeholders que respetan la estructura de las secciones del formulario
import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const ClientFormSkeleton = () => {
  return (
    <>
      {/* Header Buttons Skeleton - Skeleton de los botones del header */}
      <div className="flex items-center flex-wrap gap-3 absolute right-4 top-2">
        <Skeleton className="h-10 w-24 rounded-full bg-hover-press" />
        <Skeleton className="h-10 w-32 rounded-full bg-hover-press" />
      </div>

      <div className="px-6 pt-4">
        {/* Información de la Empresa - Company Information */}
        <div className="space-y-4 mb-6 pb-6 gap-4 grid grid-cols-1 md:grid-cols-6 pt-4 border-b border-card-border">
          <div className="col-span-1 md:col-span-2">
            <Skeleton className="h-6 w-40 rounded-full mb-2 bg-hover-press" />
            <Skeleton className="h-4 w-52 rounded-full bg-hover-press" />
          </div>
          <div className="col-span-1 md:col-span-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Nombre empresa - CIF */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-16 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              {/* Dirección */}
              <div className="space-y-2 md:col-span-2">
                <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              {/* Código postal - Ciudad */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-16 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              {/* Provincia - País */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-16 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
            </div>
          </div>
        </div>

        {/* Información del Usuario - User Information */}
        <div className="space-y-4 mb-6 pb-6 gap-4 grid grid-cols-1 md:grid-cols-6 pt-4 border-b border-card-border">
          <div className="col-span-1 md:col-span-2">
            <Skeleton className="h-6 w-40 rounded-full mb-2 bg-hover-press" />
            <Skeleton className="h-4 w-52 rounded-full bg-hover-press" />
          </div>
          <div className="col-span-1 md:col-span-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                <div className="flex gap-2">
                  <Skeleton className="h-10 flex-1 rounded-md bg-hover-press" />
                  <Skeleton className="h-10 w-10 rounded-md bg-hover-press" />
                </div>
              </div>
              <div className="space-y-2">
                <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
            </div>
          </div>
        </div>

        {/* Información Comercial - Commercial Information */}
        <div className="space-y-4 mb-6 pb-6 gap-4 grid grid-cols-1 md:grid-cols-6 pt-4 border-b border-card-border">
          <div className="col-span-1 md:col-span-2">
            <Skeleton className="h-6 w-40 rounded-full mb-2 bg-hover-press" />
            <Skeleton className="h-4 w-52 rounded-full bg-hover-press" />
          </div>
          <div className="col-span-1 md:col-span-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* ID Comercial */}
              <div className="space-y-2 md:col-span-2">
                <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              {/* Tipo de Empresa */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-32 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              {/* Origen del Cliente */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-36 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              {/* Frecuencia de Facturación */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-40 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              {/* Tipo de Pedido */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              {/* URL de Tienda */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
              {/* Estimación Mensual de Pedidos */}
              <div className="space-y-2">
                <Skeleton className="h-4 w-48 rounded-full bg-hover-press" />
                <Skeleton className="h-10 w-full bg-hover-press" />
              </div>
            </div>
          </div>
        </div>

        {/* Contactos - Contacts */}
        <div className="space-y-4 mb-6 pb-6 gap-4 grid grid-cols-1 md:grid-cols-6 pt-4">
          <div className="col-span-1 md:col-span-2">
            <Skeleton className="h-6 w-32 rounded-full mb-2 bg-hover-press" />
            <Skeleton className="h-4 w-52 rounded-full bg-hover-press" />
          </div>
          <div className="col-span-1 md:col-span-4">
            <div className="space-y-6">
              {/* Contacto 1 */}
              <div className="space-y-4 p-4 border border-card-border rounded-lg bg-card-bg">
                <div className="flex items-center justify-between mb-2">
                  <Skeleton className="h-5 w-24 rounded-full bg-hover-press" />
                  <Skeleton className="h-8 w-8 rounded-md bg-hover-press" />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
                    <Skeleton className="h-10 w-full bg-hover-press" />
                  </div>
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-24 rounded-full bg-hover-press" />
                    <Skeleton className="h-10 w-full bg-hover-press" />
                  </div>
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-28 rounded-full bg-hover-press" />
                    <Skeleton className="h-10 w-full bg-hover-press" />
                  </div>
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-20 rounded-full bg-hover-press" />
                    <Skeleton className="h-10 w-full bg-hover-press" />
                  </div>
                </div>
              </div>
              {/* Botón agregar contacto */}
              <Skeleton className="h-10 w-40 rounded-full bg-hover-press" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

